import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  IconButton,
  Typography,
  LinearProgress,
  Button,
  Chip,
  Divider,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import PropTypes from "prop-types";
import { API_get_calendar_messages_tomorrow } from "./utils/http";
import dayjs from "dayjs";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CalendarMess() {
  const [value, setValue] = useState(1);

  //   call api
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetch_data(query_string) {
    await API_get_calendar_messages_tomorrow(query_string, (data) => {
      setData(data.data);
      setLoading(false);
    });
  }

  const copyToClipboard = (text) => {
    try {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
      } else {
        navigator.clipboard
          .writeText(text)
          .then(() => {})
          .catch((err) => {
            console.error("Could not copy text: ", err);
            fallbackCopyTextToClipboard(text);
          });
      }
    } catch (err) {
      console.error("Clipboard error: ", err);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      const msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text was " + msg);
      if (!successful) {
      }
    } catch (err) {
      console.error("Fallback: Could not copy text: ", err);
    }

    document.body.removeChild(textArea);
  };

  useEffect(() => {
    fetch_data("tomorrow");
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  if (loading) {
    return <LinearProgress />;
  }
  if (error) {
    return <AlertCus condition={error} message="Error" />;
  }
  if (data.length === 0) {
    return <Typography>No data</Typography>;
  }
  if (data.length > 0) {
    return (
      <Box sx={{ width: "100%", maxWidth: 1200, mx: "auto" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 1,
            px: 1,
            pt: 1,
          }}
        >
          {/* <Button
            onClick={() => fetch_data("tomorrow")}
            variant="outlined"
            size="small"
            startIcon={<RefreshIcon />}
          >
            Refresh
          </Button> */}
          <Chip
            label={`${data.length} booking${data.length !== 1 ? "s" : ""}`}
            size="small"
            color="primary"
            variant="outlined"
          />
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={`Today (${dayjs().format("ddd DD/MM")})`}
              {...a11yProps(0)}
              onClick={() => fetch_data("today")}
            />
            <Tab
              label={`Tomorrow (${dayjs().add(1, "day").format("ddd DD/MM")})`}
              {...a11yProps(1)}
              onClick={() => fetch_data("tomorrow")}
            />
            <Tab
              label={dayjs().add(2, "day").format("ddd DD/MM")}
              {...a11yProps(2)}
              onClick={() => fetch_data("next_2_days")}
            />
            <Tab
              label={dayjs().add(3, "day").format("ddd DD/MM")}
              {...a11yProps(3)}
              onClick={() => fetch_data("next_3_days")}
            />
            <Tab
              label={dayjs().add(4, "day").format("ddd DD/MM")}
              {...a11yProps(4)}
              onClick={() => fetch_data("next_4_days")}
            />
          </Tabs>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {data.map((item) => (
            <Card
              key={item._id}
              sx={{
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                transition: "box-shadow 0.2s, border-color 0.2s",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  borderColor: "primary.light",
                },
              }}
            >
              <Box
                sx={{
                  px: 3,
                  py: 1.5,
                  bgcolor: "grey.50",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  {item.booking_number}
                </Typography>
                <Chip
                  label={item.day_index}
                  size="small"
                  color="primary"
                  sx={{ fontWeight: 600 }}
                />
              </Box>

              <CardContent
                sx={{
                  p: 3,
                  "&:last-child": { pb: 3 },
                  display: "flex",
                  gap: 3,
                }}
              >
                <Box
                  sx={{
                    width: "40%",
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  {[
                    { label: "Customer", value: item.customer_name },
                    {
                      label: "Phone",
                      value:
                        item.customer_phone === "TBA"
                          ? "—"
                          : item.customer_phone,
                    },
                    { label: "Itinerary", value: item.activity_label },
                    { label: "Accom", value: item.accommodation_label },
                  ].map((row) => (
                    <Box
                      key={row.label}
                      sx={{ display: "flex", alignItems: "baseline", gap: 1 }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          fontWeight: 600,
                          minWidth: 80,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          fontSize: "0.7rem",
                        }}
                      >
                        {row.label}
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {row.value}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Divider orientation="vertical" flexItem />

                <Box sx={{ width: "60%", minWidth: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1.5,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.secondary",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        fontSize: "0.7rem",
                      }}
                    >
                      Message
                    </Typography>
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => copyToClipboard(item.message_tool)}
                      sx={{
                        bgcolor: "primary.50",
                        "&:hover": { bgcolor: "primary.100" },
                      }}
                    >
                      <ContentCopyTwoToneIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",
                      lineHeight: 1.7,
                      color: "text.primary",
                    }}
                  >
                    {item.message_tool}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    );
  }
}
